<template>
  <select
    :class="{ 'is-invalid': error, multiple: multiple }"
    :data-attribute="attribute"
    :disabled="disabled"
    :multiple="multiple"
    :name="name"
    :style="multiple ? 'height: ' + (Object.keys(choices).length * 1.4375 + 2.25 + 0.125 + 'rem;') : ''"
    class="form-select"
    @change="$emit('update:data', $event.target.value)"
  >
    <option
      v-if="!hideEmpty && false"
      :key="'NULL'"
      :selected="localValue === null || localValue === 'NULL'"
      :value="'NULL'"
    ></option>
    <option
      v-for="(option, index) in choices"
      :key="index"
      :selected="
        localValue &&
        (localValue == option.value || (typeof localValue === 'array' && localValue.includes(option.value)))
      "
      :value="option.value"
    >
      {{ option.text.toLocaleString($page.props.locale) }}
    </option>
  </select>
</template>

<script>
import { ref } from 'vue';

export default {
  props: {
    name: { type: String, default: '' },
    value: { type: [String, Number, Array], default: () => null },
    attribute: { type: String, default: '' },
    error: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    choices: { type: Object, default: () => {} },
    hideEmpty: { type: Boolean, default: false },
  },
  emits: ['update:data'],
  setup(props) {
    const localValue = ref(props.value);

    return {
      localValue,
    };
  },
};
</script>
